// src/config/badgesCloture.config.ts — SCE Issues
// Libellés et aide contextuelle des badges de clôture (Lot 3, demande 5).
//
// ─── Pourquoi un fichier à part ───
//
// Les VALEURS stockées vivent dans issue.types.ts (`BadgeCloture`) : c'est ce
// qui doit correspondre, au caractère près, à la liste de choix SharePoint.
// Les TEXTES affichés vivent ici : ils peuvent être reformulés à la demande
// des coordinateurs sans toucher ni au type, ni à SharePoint, ni aux données
// déjà écrites. Même séparation que metiers.config.ts.
//
// Les textes d'explication reprennent mot pour mot ceux fournis par les
// coordinateurs le 18/09/2026. Ce sont eux qui ont défini ces catégories :
// l'aide doit parler leur langue, pas celle du développeur.

import type { BadgeCloture } from '@/types/issue.types'

export interface DefinitionBadge {
  /** Libellé complet (ex. « Fiche de Non Conformité Tests »). */
  signification: string
  /** Ce que le badge engage — affiché en aide contextuelle au moment du choix. */
  explication: string
  /**
   * Libellé court pour la rangée dense du bureau, dont la colonne est étroite.
   * Seul « Rapport de problème » est abrégé : le libellé complet reste dans
   * l'infobulle.
   */
  court: string
}

export const DEFINITIONS_BADGES: Record<BadgeCloture, DefinitionBadge> = {
  'FNC-T': {
    signification: 'Fiche de Non Conformité Tests',
    explication:
      'Le problème est élevé et tracé dans l’outil qualité, documenté pour le client.',
    court: 'FNC-T',
  },
  'NC-S': {
    signification: 'Non Compliance Supplier',
    explication:
      'Vrai problème fournisseur (pièce renvoyée par exemple), documenté et géré par l’AQ.',
    court: 'NC-S',
  },
  TQC: {
    signification: 'Tel Que Construit',
    explication:
      'Sera revu lors du TQC, phase où les BE font le point sur tous les problèmes ' +
      'rencontrés pendant le projet, pour mettre à jour l’étude et les plans et ne ' +
      'pas reproduire l’erreur. Surtout valable en ELEC et MECA.',
    court: 'TQC',
  },
  'Rapport de problème': {
    signification: 'Rapport de problème Windchill',
    explication:
      'Renseigné et tracé dans Windchill PLM, avec des actions qui en découlent.',
    court: 'Rapport',
  },
  Autre: {
    signification: 'Autre',
    explication: 'Tous les autres cas, problème corrigé en direct par exemple.',
    court: 'Autre',
  },
}
